import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
import { loadGlimrTags } from 'utils/consent'

const Glimr = () => {
  const props = {
    glimrUrl: useSelector((state) => get(state, 'config.urls.glimrUrl')),
    apiUrl: useSelector((state) => get(state, 'config.urls.api')),
    userId: useSelector((state) => get(state, 'user.id')),
    loggedIn: useSelector((state) => get(state, 'authentication.loggedIn')),
    bearerToken: useSelector((state) => get(state, 'authentication.bearerToken')),
  }

  useEffect(() => {
    loadGlimrTags(props)
  }, [props, props.userId])
  return null
}

export default Glimr
